import http from '@/helpers/Http';

export default {
    namespaced: true,
    state: {
        items: {},
        location: {},
        selected: {},
    },
    getters: {
        items: state => state.items,
        location: state => state.location,
        selected: state => state.selected,
    },
    mutations: {
        setItems(state, items) {
            state.items = items;
        },
        setLocation(state, location) {
            state.location = location
        },
        setSelected(state, selected) {
            state.selected = selected;
        }
    },
    actions: {
        async check({ commit }, payload) {
            const response = await http.post('wideband/appointments/check', payload);

            commit('setItems', response.data.appointments);
            commit('setLocation', response.data.location);

            return response;
        },
        async reschedule({ state, rootState }) {
            const response = await http.post('wideband/appointments/reschedule', {
                appointmentId: rootState.wideband.orders.selected.appointment_id,
                timeSlot: state.selected.timeSlot,
                startTimeRaw: state.selected.startTimeRaw,
                endTimeRaw: state.selected.endTimeRaw,
            });

            return response;
        },
        async reserve({ commit }, payload) {
            const response = await http.post('wideband/appointments/reserve', payload);

            return response;
        }
    }
}